/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_RawInputs */

const en_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const es_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const fr_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const de_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const ja_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const zh_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const ar_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const id_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const it_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const ru_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const pt_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

const ko_val_raw = /** @type {(inputs: Val_RawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAW`)
};

/**
* | output |
* | --- |
* | "RAW" |
*
* @param {Val_RawInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_raw = /** @type {((inputs?: Val_RawInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_RawInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_raw(inputs)
	if (locale === "es") return es_val_raw(inputs)
	if (locale === "fr") return fr_val_raw(inputs)
	if (locale === "de") return de_val_raw(inputs)
	if (locale === "ja") return ja_val_raw(inputs)
	if (locale === "zh") return zh_val_raw(inputs)
	if (locale === "ar") return ar_val_raw(inputs)
	if (locale === "id") return id_val_raw(inputs)
	if (locale === "it") return it_val_raw(inputs)
	if (locale === "ru") return ru_val_raw(inputs)
	if (locale === "pt") return pt_val_raw(inputs)
	return ko_val_raw(inputs)
});